import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import {
  Badge,
  Card,
  Group,
  Loader,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useTranslation } from "react-i18next";

import { EmptyMessage } from "@components/shared";

export default function AssessmentInstrumentChecklist({ instrumentId }) {
  const { t } = useTranslation();
  const [checklist, setChecklist] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChecklist();
  }, [instrumentId]);

  function fetchChecklist() {
    setLoading(true);
    axios
      .get(`/assessment-instruments/${instrumentId}/checklist/`)
      .then(({ data }) => {
        setChecklist(data.response[0] || null);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setChecklist(null);
        toast.error(err);
      });
  }

  if (loading) {
    return (
      <Group justify="center" py="xl">
        <Loader size="sm" />
      </Group>
    );
  }

  if (!checklist) {
    return <EmptyMessage />;
  }

  const slots = checklist.slots || [];

  return (
    <Stack gap="md">
      <Card>
        <Group gap="md" wrap="wrap">
          <div>
            <Text size="xs" c="dimmed">
              Required
            </Text>
            <Text fw={700}>{checklist.required_count ?? 0}</Text>
          </div>
          <div>
            <Text size="xs" c="dimmed">
              Filled
            </Text>
            <Text fw={700}>{checklist.filled_count ?? 0}</Text>
          </div>
          <div>
            <Text size="xs" c="dimmed">
              Remaining
            </Text>
            <Text fw={700}>{checklist.remaining_count ?? 0}</Text>
          </div>
          <Badge
            variant="light"
            color={checklist.is_complete ? "green" : "yellow"}
          >
            {checklist.is_complete ? "Complete" : "Incomplete"}
          </Badge>
          <Badge
            variant="light"
            color={checklist.reorder_enabled ? "green" : "gray"}
          >
            Reorder {checklist.reorder_enabled ? "enabled" : "disabled"}
          </Badge>
        </Group>
      </Card>

      <Title order={4}>Slots</Title>
      {!slots.length && <EmptyMessage />}
      {slots.map((slot) => (
        <Card key={slot.conceptual_item_id || `${slot.conceptual_root}-${slot.facet}`}>
          <Group justify="space-between" align="flex-start">
            <div>
              <Text fw={700}>
                {slot.facet_label || slot.facet}
              </Text>
              <Text size="sm" c="dimmed">
                {slot.conceptual_root_label || slot.conceptual_root}
              </Text>
            </div>
            <Badge variant="light" color={slot.filled ? "green" : "gray"}>
              {slot.filled ? t("yes") : t("no")}
            </Badge>
          </Group>
        </Card>
      ))}
    </Stack>
  );
}
